import React, { Component } from 'react'
import { ArticleAuditApi } from 'trill-api-admin-client'
import { Dimmer, Loader, Header, Icon, Button } from 'semantic-ui-react'
import _ from 'lodash'
import moment from 'moment'

import DataTable from '../../../components/DataTable'
import ApiErrorMessage from '../../../components/ApiErrorMessage'

import GetPermission from '../../../GetPermission'
import CancelablePromise from '../../../CancelablePromise'
import { ArticleAuditSummaryStatus, ArticleAuditSummaryStatusText } from '../../../enums/ArticleAuditSummary'
import { ArticleUserAuditStatus } from '../../../enums/ArticleAudit'
import PublishDatetimeRangePicker from '../../../components/PublishDatetimeRangePicker'

const articleAuditApi = new ArticleAuditApi()

let getArticleAudits

class ArticleAuditSummary extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isBusy: false,
      apiError: null,
      permission: GetPermission('article'),
      tableData: {
        processingManualItems: [],
        processingAutoPublishItems: [],
        confirmingItems: [],
        confirmedItems: [],
      },
      filterData: {
        createDateRangeStartAt: moment()
          .subtract(1, 'day')
          .set({ hour: 16, minute: 30, second: 0, millisecond: 0 }),
        createDateRangeEndAt: moment().endOf('day'),
        clearCreateDateRange: true,
      },
    }

    this.handlePageRestoredFromBfCache = this.handlePageRestoredFromBfCache.bind(this)
  }

  UNSAFE_componentWillMount() {
    window.addEventListener('pageshow', this.handlePageRestoredFromBfCache)

    this.retrieveArticleAuditSummary()
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.handlePageRestoredFromBfCache)
  }

  handlePageRestoredFromBfCache(event) {
    if (event.persisted) {
      window.location.reload()
    }
  }

  retrieveArticleAuditSummary = () => {
    this.setState({
      isBusy: true,
      apiError: null,
    })
    getArticleAudits = CancelablePromise(articleAuditApi.getArticleAuditSummary(this.getRequestQuery()))
    getArticleAudits.promise
      .then(response => {
        const auditSummary = response.data
        const { tableData } = this.state

        tableData.processingManualItems = auditSummary.processingManual
        tableData.processingAutoPublishItems = auditSummary.processingAutoPublish
        tableData.confirmingItems = auditSummary.confirming
        tableData.confirmedItems = auditSummary.confirmed
        this.setState({
          isBusy: false,
          tableData,
        })
      })
      .catch(error => {
        if (error.isCanceled) {
          return
        }

        const { tableData } = this.state

        tableData.processingManualItems = []
        tableData.processingAutoPublishItems = []
        tableData.confirmingItems = []
        tableData.confirmedItems = []

        this.setState({
          isBusy: false,
          apiError: error,
          tableData,
        })
      })
  }

  getRequestQuery() {
    const { filterData } = this.state
    const filtering = []

    let createDateRangeStartAt = moment()
      .subtract(1, 'day')
      .set({ hour: 16, minute: 30, second: 0, millisecond: 0 })
    let createDateRangeEndAt = moment().endOf('day')

    if (!filterData.clearCreateDateRange) {
      createDateRangeStartAt = filterData.createDateRangeStartAt
      createDateRangeEndAt = filterData.createDateRangeEndAt
    }
    filtering.push(`createdAt >= '${createDateRangeStartAt.toISOString()}'`)
    filtering.push(`createdAt <= '${createDateRangeEndAt.toISOString()}'`)

    const query = { filtering }

    return _.omitBy(query, value => !_.isNumber(value) && _.isEmpty(value))
  }

  buildHrefForProcessingItem(status, mediumItemAutoPublish) {
    const { filterData } = this.state
    const createDateRangeStartAt = filterData.createDateRangeStartAt
    const createDateRangeEndAt = filterData.createDateRangeEndAt
    let filteringObject = {}
    if (status === 'all') {
      const filterarticleEvaluateStatusesValue = [
        ArticleAuditSummaryStatus.EXCEPTION,
        ArticleAuditSummaryStatus.ERROR,
        ArticleAuditSummaryStatus.RISKY,
        ArticleAuditSummaryStatus.NEEDS_REVISION,
        ArticleAuditSummaryStatus.NEEDS_RESERVATION,
      ]
      filteringObject = {
        mediumItemAutoPublish,
        articleUserAuditStatus: ArticleUserAuditStatus.UNREVIEW,
        articleEvaluateStatuses: filterarticleEvaluateStatusesValue,
        createDateRangeStartAt: createDateRangeStartAt.toISOString(),
        createDateRangeEndAt: createDateRangeEndAt.toISOString(),
      }
    } else if (status === ArticleAuditSummaryStatus.EXCEPTION) {
      filteringObject = {
        mediumItemAutoPublish,
        articleUserAuditStatus: ArticleUserAuditStatus.UNREVIEW,
        articleEvaluateStatuses: [ArticleAuditSummaryStatus.EXCEPTION],
        createDateRangeStartAt: createDateRangeStartAt.toISOString(),
        createDateRangeEndAt: createDateRangeEndAt.toISOString(),
      }
    } else {
      filteringObject = {
        mediumItemAutoPublish,
        articleUserAuditStatus: ArticleUserAuditStatus.UNREVIEW,
        articleEvaluateStatuses: [status],
        createDateRangeStartAt: createDateRangeStartAt.toISOString(),
        createDateRangeEndAt: createDateRangeEndAt.toISOString(),
      }
    }

    const encodedFiltering = encodeURIComponent(JSON.stringify(filteringObject))
    return `/article-audits?filtering=${encodedFiltering}`
  }

  buildHrefForConfirmingItem(status) {
    const { filterData } = this.state
    const createDateRangeStartAt = filterData.createDateRangeStartAt
    const createDateRangeEndAt = filterData.createDateRangeEndAt
    const filteringObject = {
      articleUserAuditStatus: status,
      createDateRangeStartAt: createDateRangeStartAt.toISOString(),
      createDateRangeEndAt: createDateRangeEndAt.toISOString(),
    }

    const encodedFiltering = encodeURIComponent(JSON.stringify(filteringObject))
    return `/article-audits?filtering=${encodedFiltering}`
  }

  buildHrefForConfirmedItem(status, shannonSubmissionAllowed) {
    const { filterData } = this.state
    const createDateRangeStartAt = filterData.createDateRangeStartAt
    const createDateRangeEndAt = filterData.createDateRangeEndAt
    const filteringObject = {
      articleUserAuditStatus: ArticleUserAuditStatus.UNREVIEW,
      articleEvaluateStatuses: [status],
      shannonSubmissionAllowed,
      createDateRangeStartAt: createDateRangeStartAt.toISOString(),
      createDateRangeEndAt: createDateRangeEndAt.toISOString(),
    }

    const encodedFiltering = encodeURIComponent(JSON.stringify(filteringObject))
    return `/article-audits?filtering=${encodedFiltering}`
  }

  handleDateRangePickerEvent = (event, picker) => {
    if (event.type === 'apply' || event.type === 'cancel') {
      let startDate
      let endDate
      let clearDateRange

      if (event.type === 'apply') {
        startDate = picker.startDate
        endDate = picker.endDate
        clearDateRange = false
      } else if (event.type === 'cancel') {
        startDate = moment()
          .subtract(1, 'day')
          .set({ hour: 16, minute: 30, second: 0, millisecond: 0 })
        endDate = moment().endOf('day')
        clearDateRange = true
      }

      const filterData = this.state.filterData
      filterData.createDateRangeStartAt = startDate
      filterData.createDateRangeEndAt = endDate
      filterData.clearCreateDateRange = clearDateRange

      this.setState({ filterData }, () => {
        this.retrieveArticleAuditSummary()
      })
    }
  }

  render() {
    const { isBusy, apiError, tableData, filterData } = this.state

    return (
      <div className="ArticleAuditSummary">
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 12,
            flexWrap: 'wrap',
          }}
        >
          <Header as="h1" style={{ marginBottom: 0 }}>
            <Icon name="bullhorn" />
            <Header.Content>記事監査状況 レポート</Header.Content>
          </Header>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <PublishDatetimeRangePicker
              timePicker
              timePicker24Hour
              startDate={filterData.createDateRangeStartAt}
              endDate={filterData.createDateRangeEndAt}
              onEvent={this.handleDateRangePickerEvent}
              clear={filterData.clearCreateDateRange}
              placeholderText="登録日時で絞り込み"
            />
            <span style={{ color: '#666', fontSize: 12 }}>※デフォルト 昨日 16:30:00〜</span>
          </div>
        </div>

        <Dimmer active={isBusy} inverted>
          <Loader>読み込み中</Loader>
        </Dimmer>

        <ApiErrorMessage error={apiError} />

        <br />
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ width: '49%' }}>
            <h3>マニュアル｜要対応（未レビュー）</h3>
            <DataTable
              rowKey="id"
              items={tableData.processingManualItems}
              columns={[
                {
                  label: 'ステータス',
                  align: 'center',
                  render: item => ArticleAuditSummaryStatusText[item.status],
                  collapsing: false,
                },
                {
                  label: '対応 残り',
                  align: 'center',
                  field: 'count',
                },
                {
                  label: 'フィルタへ',
                  align: 'center',
                  render: item => (
                    <Button.Group primary>
                      <Button primary as="a" href={this.buildHrefForProcessingItem(item.status, false)} icon="filter" />
                    </Button.Group>
                  ),
                },
              ]}
            />

            <h3>オート｜要対応（未レビュー）</h3>
            <DataTable
              rowKey="id"
              items={tableData.processingAutoPublishItems}
              columns={[
                {
                  label: 'ステータス',
                  align: 'center',
                  render: item => ArticleAuditSummaryStatusText[item.status],
                  collapsing: false,
                },
                {
                  label: '対応 残り',
                  align: 'center',
                  field: 'count',
                },
                {
                  label: 'フィルタへ',
                  align: 'center',
                  render: item => (
                    <Button.Group primary>
                      <Button primary as="a" href={this.buildHrefForProcessingItem(item.status, true)} icon="filter" />
                    </Button.Group>
                  ),
                },
              ]}
            />
          </div>

          <div style={{ width: '2%' }}></div>

          <div style={{ width: '49%', display: 'flex', flexDirection: 'column', gap: 33 }}>
            <div>
              <h3>確認中</h3>
              <DataTable
                rowKey="id"
                items={tableData.confirmingItems}
                columns={[
                  {
                    label: 'ステータス',
                    align: 'center',
                    render: item => ArticleAuditSummaryStatusText[item.status],
                    collapsing: false,
                  },
                  {
                    label: '対応 残り',
                    align: 'center',
                    field: 'count',
                  },
                  {
                    label: 'フィルタへ',
                    align: 'center',
                    render: item => (
                      <Button.Group primary>
                        <Button primary as="a" href={this.buildHrefForConfirmingItem(item.status)} icon="filter" />
                      </Button.Group>
                    ),
                  },
                ]}
              />
            </div>

            <div>
              <h3>事後確認（未レビュー）</h3>
              <DataTable
                rowKey="id"
                items={tableData.confirmedItems}
                columns={[
                  {
                    label: 'ステータス',
                    align: 'center',
                    render: item => ArticleAuditSummaryStatusText[item.status],
                    collapsing: false,
                  },
                  {
                    label: '連携',
                    align: 'center',
                    field: 'countWithShannonOn',
                  },
                  {
                    label: '非連携',
                    align: 'center',
                    field: 'countWithShannonOff',
                  },
                  {
                    label: 'フィルタへ',
                    align: 'center',
                    render: item => (
                      <Button.Group primary>
                        <Button
                          style={{ marginRight: '8px' }}
                          icon="filter"
                          as="a"
                          href={this.buildHrefForConfirmedItem(item.status, true)}
                        />
                        <Button as="a" href={this.buildHrefForConfirmedItem(item.status, false)} icon="filter" />
                      </Button.Group>
                    ),
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ArticleAuditSummary
